const hideEmptySections = () => {
  document.querySelectorAll('.section').forEach((section) => {
    if (!section.children.length) {
      section.style.display = 'none';
    }
  });
};

export { hideEmptySections };
